import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

import type { CoachingCoacheeCohortPathParams } from '../../cohort';

/** Old Pending URL — send people to Action required. */
export default class CoachingCoacheeCohortSessionsPendingRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    const { program_id, cohort_id } = this.paramsFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortPathParams;

    this.router.replaceWith(
      'coaching.coachee.cohort.sessions.action-required',
      program_id,
      cohort_id
    );
  }
}
